<div *ngIf="translationPrefix + '.modal.article.url' | finHasLocalizationKey">
  <fcom-notification class="block mr-small-t">
    <button class="underline focus-inset" (click)="showModal = true">
      {{ translationPrefix + '.linkText' | finLocalization }}
    </button>
  </fcom-notification>

  <fcom-modal
    [title]="translationPrefix + '.modal.title' | finLocalization"
    [open]="showModal"
    [buttons]="ModalButtons.CUSTOM"
    (close)="showModal = false"
  >
    <fin-cms-json-content class="block pr-large-x pr-medium-y" [template$]="modalArticle$"></fin-cms-json-content>

    <div buttons>
      <fcom-button
        class="mr-xsmall-r"
        [text]="'actions.close' | finLocalization"
        [theme]="ButtonTheme.SECONDARY"
        [aria]="{ label: 'actions.close' | finLocalization, role: 'button' }"
        (click)="showModal = false"
      ></fcom-button>
      <fcom-button
        *ngIf="upsell"
        (click)="emitUpsellClick()"
        [theme]="ButtonTheme.PRIMARY_HEATHER"
        [text]="translationPrefix + '.modal.upsellButton' | finLocalization"
        [aria]="{ label: translationPrefix + '.modal.upsellButton' | finLocalization, role: 'button' }"
      ></fcom-button>
    </div>
  </fcom-modal>
</div>
